import Konva from 'konva';
import * as _ from 'lodash';
import { AreaInformation } from '../area/AreaInformation';
import { AreaRect } from '../area/AreaRect';
import { HGroup } from '../area/HGroup';
import { Rectangle } from '../area/Rectangle';
import { VLine } from '../area/VLine';
import { SC_Input } from '../input/SC_Input';
import { DrawRoofForPanel } from '../panel/drawRoofForPanel';
import { Modul } from '../panel/Modul';
import { AreaFinder } from '../roof/areaFinder';
import { SC_Beam } from '../roof/SC_Beam';
import { Global } from '../utilities/global';
import { Statics } from '../utilities/statics';
import { MountingSystem } from './MountingSystem';
import { Sol50 } from './Sol50';
import { Sol50OnRoof } from './Sol50OnRoof';
import { SubFrame } from './subFrame';
import {
    Area_collectInformation,
    Area_determine,
    Purlin_VProfil_correctLength,
    Purlin_VProfil_walkArea,
} from './vProfilPurlin';

export class DrawVProfile {
    //static cutlistGroup: any = [];

    public static drawVProfile() {
        if (SC_Input.iBeamType == SC_Beam.PURLIN) {
            DrawVProfile.Purlin_VProfile_find();
        } else {
            DrawVProfile.VProfile_find();
        }
    }
    static Purlin_VProfile_find(): void {
        var rect: Rectangle;
        var area_info: AreaInformation;
        var t: number;
        var i: number;
        var j: number;
        var aGroupTmp: any[];
        var aAreaList: any[];
        var areaHLine: AreaRect;
        var aAreaInfo: any[];
        var nVerticalSpace: number;
        // t = getTimer();
        //detect areas
        aAreaList = Area_determine();

        let oldLength = aAreaList.length;
        do {
            oldLength = aAreaList.length;
            const temp1 = aAreaList;
            const indexChecked: any = [];
            const res: any = [];
            for (let a = 0; a < temp1.length; a++) {
                if (indexChecked.indexOf(a) == -1) {
                    let touched = false;
                    let index = -1;
                    const r = [...temp1[a]];
                    for (let b = a + 1; b < temp1.length; b++) {
                        if (indexChecked.indexOf(b) == -1) {
                            const aa = temp1[a];
                            const bb = temp1[b];
                            aa.forEach((ai: any) => {
                                const area1 = {
                                    x: ai.x - 2,
                                    y: ai.y - 4,
                                    width: ai.width + 2,
                                    height: ai.height + 4,
                                };
                                bb.forEach((bi: any) => {
                                    const area2 = {
                                        x: bi.x - 2,
                                        y: bi.y - 4,
                                        width: bi.width + 2,
                                        height: bi.height + 4,
                                    };
                                    if (Modul.haveIntersection(area1, area2)) {
                                        touched = true;
                                        indexChecked.push(b);
                                    }
                                });
                            });
                        }
                        if (touched) {
                            touched = false;
                            temp1[b].forEach((arr: any) => {
                                r.push(arr);
                            });
                        }
                    }
                    r.forEach((it: any) => {
                        it.aGroup = r;
                    });
                    res.push(r);
                }
            }
            aAreaList = res;
        } while (oldLength != aAreaList.length);

        //rectangle buffer
        rect = new Rectangle();
        //worst ranges of each area
        aAreaInfo = Area_collectInformation(aAreaList);
        Sol50OnRoof.aVProfile = new Array();
        for (i = 0; i < aAreaInfo.length; i++) {
            area_info = aAreaInfo[i];
            Purlin_VProfil_walkArea(aAreaList[i], area_info);
        }
        //correct length
        Purlin_VProfil_correctLength();

        let pname: any = '';
        // TODO: Remove hard coded values
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            pname = 'SOL-50 XL-Vertikalprofil 2m pressblank'; //SOL-50 XL-Vertikalprofil 2m pressblank
        } else if (
            SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M ||
            (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 13)
        ) {
            pname = 'SOL-50 XL-Vertikalprofil 2m pressblank'; //SOL-50 XL-Vertikalprofil 2m pressblank
        } else if (
            SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M ||
            (SC_Input.iMountSys > 12 && SC_Input.iMountSys < 15)
        ) {
            pname = 'SOL-50 XL-Vertikalprofil 4m pressblank'; //	SOL-50 XL-Vertikalprofil 4m pressblank
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            pname = 'SOL-50 XL-Vertikalprofil 4m pressblank'; //SOL-50 XL-Vertikalprofil 4m pressblank
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            pname = 'SOL-50 Standard Horizontalendkappe VE10 schwarz';
        }
        //this.cutlistGroup = [];
        let lengthArr: any = [];
        for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
            let vprofileTmp = Sol50OnRoof.aVProfile[i];
            //correct by cover trim and vertical overlap
            vprofileTmp.t -= Sol50OnRoof.nVPOverLapTop;
            vprofileTmp.b += Sol50OnRoof.nVPOverLapBottom;

            //t= y start position
            //b = y end position
            //x = x axis position

            const adj = Sol50OnRoof.nVProfileHeight;
            SubFrame.drawVprofileKonva([
                vprofileTmp.x - adj / 2,
                vprofileTmp.t,
                vprofileTmp.x + adj / 2,
                vprofileTmp.t,
                vprofileTmp.x + adj / 2,
                vprofileTmp.b,
                vprofileTmp.x - adj / 2,
                vprofileTmp.b,
            ]);

            if (SubFrame.isProfileCutEnabled) {
                //draw profile cutting
                let y1: number = 0;
                let y2: number = 0;
                let y3: number = 0;
                let y4: number = 0;

                let y: number = 0;
                //l = start of line
                //r = length of line
                //y = y axis of line
                const x1 = vprofileTmp.x - 10;
                y1 = vprofileTmp.t + Sol50OnRoof.nHProfileLen; // inc
                const x2 = vprofileTmp.x - 10;
                y2 = vprofileTmp.t + Sol50OnRoof.nHProfileLen;
                const x3 = vprofileTmp.x + 10;
                y3 = vprofileTmp.t + Sol50OnRoof.nHProfileLen;
                const x4 = vprofileTmp.x - 10;
                y4 = vprofileTmp.t + Sol50OnRoof.nHProfileLen;
                // // SubFrame.drawHprofileKonva([x1, y1, x2, y2, x3, y3, x4, y4]);

                const length = vprofileTmp.b;
                //x = vprofileTmp.t + Sol50OnRoof.nHProfileLen;

                let len: number = 0;
                len = Sol50OnRoof.nHProfileLen;

                let prevlen = 0;

                //for profiles less than nHProfileLen (if cut never happens)
                //let notcut = length - vprofileTmp.t;
                //if(y1 > length && notcut < Sol50OnRoof.nHProfileLen){
                //   lengthArr.push(notcut);
                //    console.log('lengthArr vertical val 1',notcut);
                //}

                while (y1 < length) {
                    prevlen = y1;

                    var greenLine = new Konva.Line({
                        points: [x1, y1, x2, y2, x3, y3, x4, y4],
                        stroke: '#1F6451',
                        strokeWidth: 15,
                        lineCap: 'round',
                        lineJoin: 'round',
                    });

                    DrawRoofForPanel.subframeGroup.add(greenLine);

                    y1 = y1 + Sol50OnRoof.nHProfileLen;
                    y2 = y2 + Sol50OnRoof.nHProfileLen;
                    y3 = y3 + Sol50OnRoof.nHProfileLen;
                    y4 = y4 + Sol50OnRoof.nHProfileLen;

                    len = y1 - prevlen;
                    lengthArr.push(len);

                    //start vprofile end logic
                    y = y1 + Sol50OnRoof.nHProfileLen;
                    if (y1 < length) {
                        const nextlength = length - y1;

                        if (nextlength < Sol50OnRoof.cutProfileLen) {
                            const toMinus =
                                Sol50OnRoof.cutProfileLen - nextlength;

                            y1 = y1 - toMinus;
                            y2 = y2 - toMinus;
                            y3 = y3 - toMinus;
                            y4 = y4 - toMinus;

                            var greenLine = new Konva.Line({
                                points: [x1, y1, x2, y2, x3, y3, x4, y4],
                                stroke: '#1F6451',
                                strokeWidth: 15,
                                lineCap: 'round',
                                lineJoin: 'round',
                            });

                            DrawRoofForPanel.subframeGroup.add(greenLine);
                            //x= x + Sol50OnRoof.nHProfileLen + toMinus;

                            len = y1 - prevlen;
                            lengthArr.push(len);
                            //break;
                        }
                    }
                    //end vprofile end logic
                }
                let prev = y1 - Sol50OnRoof.nHProfileLen;
                if (length - prev > 0) {
                    len = length - prev;
                    lengthArr.push(len);
                }

                //end draw profile cutting
            }
        }
        //this.cutlistGroup = [];
        if (lengthArr.length > 0) {
            let map: any = {};

            for (var j = 0; j < lengthArr.length; j++) {
                var len = lengthArr[j].toFixed(2);
                if (Sol50OnRoof.nHProfileLen - len < 1) {
                    len = Sol50OnRoof.nHProfileLen;
                }
                if (map[len]) {
                    map[len] = map[len] + 1;
                } else {
                    map[len] = 1;
                }
            }
            const kk: any = Object.keys(map);
            const vv: any = Object.values(map);
            if (vv[0] > vv[1]) {
                const factor: any = vv[0] / vv[1];
                SC_Input.verticalLengthCovered =
                    factor * parseFloat(kk[0]) + parseFloat(kk[1]);
            } else {
                const factor: any = vv[1] / vv[0];
                SC_Input.verticalLengthCovered =
                    factor * parseFloat(kk[1]) + parseFloat(kk[0]);
            }
            let vlineLen = 0;
            let h: number = SC_Input.nModHeight / 10;

            if (Global.hgroups.length > 1) {
                const numRows = Global.hgroups.length;
                const modHeight = h * 10;
                const verticalDimensionMm = (modHeight + 24) * numRows + 96;
                vlineLen = verticalDimensionMm / 10;
            }
            // console.log('vlineLen', vlineLen);
            const keys1 = Object.keys(map);
            let newLen = 0;
            let map2: any = {}
            if(parseFloat(keys1[0]) > parseFloat(keys1[1])){
                newLen = vlineLen - parseFloat(keys1[0]) * map[keys1[0]]/map[keys1[1]]
                map2[newLen] = map[keys1[1]]
                map2[keys1[0]] = map[keys1[0]]
            } else {
                newLen = vlineLen - parseFloat(keys1[1]) * map[keys1[1]]/map[keys1[0]]
                map2[newLen] = map[keys1[0]]
                map2[keys1[1]] = map[keys1[1]]
            }
            // map[newLen] = map[newLen] + 1;
            // console.log('map', map);
            // console.log('map', map2);
            for (const [key, value] of Object.entries(map2)) {
                //const key2 = Math.abs(parseFloat(key) * 100).toFixed(0);
                var cutval = value + ' * ' + key + ' cm';
                const obj = {
                    name: pname,
                    cut: cutval,
                };
                SubFrame.cutlistGroup.push(obj);
            }
        }
        Global.cutlistGroup = SubFrame.cutlistGroup;
    }

    //commented due to error

    static VProfile_find() {
        var i: number;
        var nSparrenLeft: number;
        var iSparrenIndex: number;
        var hgroupTmp: HGroup;
        var nAbstandH: number = 1; //TFE
        var nAbstandHCurrent: number;
        var nAbstandHLast: number;
        var sModWidth: string;
        var nCurrentX: number;
        var nX: number;
        var nXMax: number;
        var vprofileTmp: VLine;
        var aTmp: any[];
        var iCurrent: number;
        var iLen: number;
        var aCol: any[];
        var sRange: string;
        var iModIndex: number;
        var nModW: number, nModH: number;
        var nCurX: number, nCurY: number;
        var rTmp: Rectangle;
        var nModWSpace: number;
        var iRaftCnt: number;
        aTmp = new Array();
        var nBeamDist1 = SC_Input.nBeamDist1 + 100;

        //drawing vprofile one by one for one hgroup first and then another(change i=1 for debug)
        for (i = 0; i < Global.hgroups.length; i++) {
            hgroupTmp = new HGroup(Global.hgroups[i]);
            if (hgroupTmp.x < nBeamDist1) {
                nX = nBeamDist1;
                iSparrenIndex = 0;
                nCurrentX = nX;
            } else {
                nX = hgroupTmp.x - nBeamDist1;
                iSparrenIndex = parseInt('' + nX / SC_Input.nBeamDist) + 1;
                nCurrentX = iSparrenIndex * SC_Input.nBeamDist + nBeamDist1;
            }

            nXMax = hgroupTmp.x + hgroupTmp.width;
            rTmp = new Rectangle();
            // nModH = hgroupTmp.height;
            // nModW = hgroupTmp.width;
            nModH = hgroupTmp.height
                ? hgroupTmp.height
                : SC_Input.nModHeight / 10;
            nModW = hgroupTmp.nModWith
                ? hgroupTmp.nModWith
                : SC_Input.nModWidth / 10;
            nCurY = hgroupTmp.y;
            //rafters
            nModWSpace = nModW + Sol50.nHorizontalAbstand;
            sModWidth = nModW.toString();
            iRaftCnt = 0;
            nAbstandHLast = Number.MAX_VALUE;
            nAbstandHCurrent = Number.MAX_VALUE;
            while (nCurrentX < nXMax) {
                iModIndex = Math.floor((nCurrentX - hgroupTmp.x) / nModWSpace);
                rTmp.x = iModIndex * nModWSpace + hgroupTmp.x;
                rTmp.y = nCurY;
                rTmp.width = nModW;
                rTmp.height = nModH;
                sRange = !Global.toggleBoundaryArea
                    ? AreaFinder.getAreaByModule(rTmp)
                    : 'h';
                nAbstandH = Statics.oSpanWidthMax[sRange][sModWidth];
                if (nAbstandH == -1) {
                    iRaftCnt = 0;
                    nCurrentX += SC_Input.nBeamDist;
                    continue;
                } else if (nAbstandH > SC_Input.nBeamDist) {
                    nAbstandH =
                        Math.floor(nAbstandH / SC_Input.nBeamDist) *
                        SC_Input.nBeamDist;
                }
                if (nAbstandHLast == nAbstandH) {
                    if (nAbstandHCurrent < nAbstandHLast) {
                        nAbstandHLast = nAbstandH;
                        nCurrentX += SC_Input.nBeamDist;
                        nAbstandHCurrent += SC_Input.nBeamDist;
                        continue;
                    }
                } else if (nAbstandHLast * 2 == nAbstandH) {
                    //double
                    if (nAbstandHCurrent < nAbstandH) {
                        nAbstandHLast = nAbstandH;
                        nCurrentX += SC_Input.nBeamDist;
                        nAbstandHCurrent += SC_Input.nBeamDist;
                        continue;
                    }
                }
                nAbstandHLast = nAbstandH;
                vprofileTmp = new VLine(null);
                vprofileTmp.t = hgroupTmp.y; //vprofile y start position
                vprofileTmp.b = hgroupTmp.y + hgroupTmp.height; //vprofile y end position
                vprofileTmp.x = nCurrentX; //vprofile x  position
                aTmp.push(vprofileTmp);
                iRaftCnt++;
                nCurrentX += SC_Input.nBeamDist;
                nAbstandHCurrent = SC_Input.nBeamDist;
            }
            //last module at twice the distance
            if (
                nAbstandH > SC_Input.nBeamDist &&
                nAbstandH == nAbstandHCurrent
            ) {
                nCurrentX -= SC_Input.nBeamDist;
                vprofileTmp = new VLine(null);
                vprofileTmp.t = hgroupTmp.y;
                vprofileTmp.b = hgroupTmp.y + hgroupTmp.height;
                vprofileTmp.x = nCurrentX;
                aTmp.push(vprofileTmp);
            }
        }
        if (aTmp.length == 0) return;
        Sol50OnRoof.aVProfile = new Array();
        //sort by x
        // aTmp.sortOn("x", Array.NUMERIC);
        aTmp = _.sortBy(aTmp, 'x');
        iLen = aTmp.length;
        iCurrent = 0;
        while (iCurrent < iLen) {
            aCol = DrawVProfile.VProfile_getCol(aTmp, iLen, iCurrent); // >>>>>>>>>>>>>>>1
            iCurrent += aCol.length;
            // aCol.sortOn("t", Array.NUMERIC);
            aCol = _.sortBy(aCol, 't');
            DrawVProfile.VProfile_optimize(aCol); // >>>>>>>>>>>>>>>2
        }

        let pname: any = '';
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            pname = 'SOL-50 XL-Vertikalprofil 2m pressblank'; //SOL-50 XL-Vertikalprofil 2m pressblank
        } else if (
            SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M ||
            (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 13)
        ) {
            pname = 'SOL-50 XL-Vertikalprofil 2m pressblank'; //SOL-50 XL-Vertikalprofil 2m pressblank
        } else if (
            SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M ||
            (SC_Input.iMountSys > 12 && SC_Input.iMountSys < 15)
        ) {
            pname = 'SOL-50 XL-Vertikalprofil 4m pressblank'; //	SOL-50 XL-Vertikalprofil 4m pressblank
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            pname = 'SOL-50 XL-Vertikalprofil 4m pressblank'; //SOL-50 XL-Vertikalprofil 4m pressblank
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            pname = 'SOL-50 Standard Horizontalendkappe VE10 schwarz';
        }
        //this.cutlistGroup = [];
        let lengthArr: any = [];

        // correct length
        for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
            vprofileTmp = Sol50OnRoof.aVProfile[i];
            //correct by cover trim and vertical overlap
            vprofileTmp.t -= Sol50OnRoof.nVPOverLapTop;
            vprofileTmp.b += Sol50OnRoof.nVPOverLapBottom;
            //t= y start position
            //b = y end position
            //x = x axis position

            const adj = Sol50OnRoof.nVProfileHeight;
            //draw vprofile
            SubFrame.drawVprofileKonva([
                vprofileTmp.x - adj / 2,
                vprofileTmp.t,
                vprofileTmp.x + adj / 2,
                vprofileTmp.t,
                vprofileTmp.x + adj / 2,
                vprofileTmp.b,
                vprofileTmp.x - adj / 2,
                vprofileTmp.b,
            ]);

            if (SubFrame.isProfileCutEnabled) {
                //draw profile cutting
                let y1: number = 0;
                let y2: number = 0;
                let y3: number = 0;
                let y4: number = 0;
                let y: number = 0;
                //l = start of line
                //r = length of line
                //y = y axis of line
                const x1 = vprofileTmp.x - 10;
                y1 = vprofileTmp.t + Sol50OnRoof.nHProfileLen; // inc
                const x2 = vprofileTmp.x - 10;
                y2 = vprofileTmp.t + Sol50OnRoof.nHProfileLen;
                const x3 = vprofileTmp.x + 10;
                y3 = vprofileTmp.t + Sol50OnRoof.nHProfileLen;
                const x4 = vprofileTmp.x - 10;
                y4 = vprofileTmp.t + Sol50OnRoof.nHProfileLen;
                // // SubFrame.drawHprofileKonva([x1, y1, x2, y2, x3, y3, x4, y4]);

                const length = vprofileTmp.b;
                //x = vprofileTmp.t + Sol50OnRoof.nHProfileLen;

                let len: number = 0;
                len = Sol50OnRoof.nHProfileLen;

                let prevlen = 0;

                //for profiles less than nHProfileLen (if cut never happens)
                // let notcut = length - vprofileTmp.t;
                //if(y1 > length && notcut < Sol50OnRoof.nHProfileLen){
                //    lengthArr.push(notcut);
                //    console.log('lengthArr vertical val 1',notcut);
                //}

                while (y1 < length) {
                    prevlen = y1;

                    var greenLine = new Konva.Line({
                        points: [x1, y1, x2, y2, x3, y3, x4, y4],
                        stroke: '#1F6451',
                        strokeWidth: 15,
                        lineCap: 'round',
                        lineJoin: 'round',
                    });

                    DrawRoofForPanel.subframeGroup.add(greenLine);

                    y1 = y1 + Sol50OnRoof.nHProfileLen;
                    y2 = y2 + Sol50OnRoof.nHProfileLen;
                    y3 = y3 + Sol50OnRoof.nHProfileLen;
                    y4 = y4 + Sol50OnRoof.nHProfileLen;

                    len = y1 - prevlen;
                    lengthArr.push(len);

                    //start vprofile end logic
                    y = y1 + Sol50OnRoof.nHProfileLen;
                    if (y1 < length) {
                        const nextlength = length - y1;

                        if (nextlength < Sol50OnRoof.cutProfileLen) {
                            const toMinus =
                                Sol50OnRoof.cutProfileLen - nextlength;

                            y1 = y1 - toMinus;
                            y2 = y2 - toMinus;
                            y3 = y3 - toMinus;
                            y4 = y4 - toMinus;

                            var greenLine = new Konva.Line({
                                points: [x1, y1, x2, y2, x3, y3, x4, y4],
                                stroke: '#1F6451',
                                strokeWidth: 15,
                                lineCap: 'round',
                                lineJoin: 'round',
                            });

                            DrawRoofForPanel.subframeGroup.add(greenLine);
                            //x= x + Sol50OnRoof.nHProfileLen + toMinus;

                            len = y1 - prevlen;
                            lengthArr.push(len);
                            //break;
                        }
                    }
                    //end vprofile end logic
                }
                let prev = y1 - Sol50OnRoof.nHProfileLen;
                if (length - prev > 0) {
                    len = length - prev;
                    lengthArr.push(len);
                }
                //end draw profile cutting
            }
        }

        //this.cutlistGroup = [];
        if (lengthArr.length > 0) {
            let map: any = {};
            for (var j = 0; j < lengthArr.length; j++) {
                var len = lengthArr[j].toFixed(2);
                if (Sol50OnRoof.nHProfileLen - len < 1) {
                    len = Sol50OnRoof.nHProfileLen;
                }
                if (map[len]) {
                    map[len] = map[len] + 1;
                } else {
                    map[len] = 1;
                }
            }
            // const kk: any = Object.keys(map);
            // const vv: any = Object.values(map);
            // if (vv[0] > vv[1]) {
            //     console.log('lengthArr vertical val 2', kk[0], kk[1]);
            //     const factor: any = vv[0] / vv[1];
            //     console.log(factor * parseFloat(kk[0]) + parseFloat(kk[1]));
            // } else {
            //     const factor: any = vv[1] / vv[0];
            //     console.log(factor * parseFloat(kk[1]) + parseFloat(kk[0]));
            // }
            let vlineLen = 0;
            let h: number = SC_Input.nModHeight / 10;

            if (Global.hgroups.length > 1) {
                const numRows = Global.hgroups.length;
                const modHeight = h * 10;
                const verticalDimensionMm = (modHeight + 24) * numRows + 96;
                vlineLen = verticalDimensionMm / 10;
            }
            // console.log('vlineLen', vlineLen);
            const keys1 = Object.keys(map);
            let newLen = 0;
            let map2: any = {}
            if(parseFloat(keys1[0]) > parseFloat(keys1[1])){
                newLen = vlineLen - parseFloat(keys1[0]) * map[keys1[0]]/map[keys1[1]]
                map2[newLen] = map[keys1[1]]
                map2[keys1[0]] = map[keys1[0]]
            } else {
                newLen = vlineLen - parseFloat(keys1[1]) * map[keys1[1]]/map[keys1[0]]
                map2[newLen] = map[keys1[0]]
                map2[keys1[1]] = map[keys1[1]]
            }
            // map[newLen] = map[newLen] + 1;
            // console.log('map', map);
            // console.log('map', map2);

            for (const [key, value] of Object.entries(map2)) {
                //const key2 = Math.abs(parseFloat(key) * 100).toFixed(0);
                var cutval = value + ' * ' + key + ' cm';
                const obj = {
                    name: pname,
                    cut: cutval,
                };
                SubFrame.cutlistGroup.push(obj);
            }
        }
        Global.cutlistGroup = SubFrame.cutlistGroup;
    }

    static VProfile_getCol(aTmp: any[], iLen: number, iStart: number): any[] {
        var vprofileTmp: VLine;
        var vprofileTmp2: VLine;
        var aResult: any[];
        var i: number, j: number;
        var nXDif: number;
        if (iLen <= iStart) {
            return null!;
        }
        vprofileTmp = aTmp[iStart];
        j = 1;
        for (i = iStart + 1; i < iLen; i++) {
            vprofileTmp2 = aTmp[i];
            nXDif = vprofileTmp2.x - vprofileTmp.x;

            if (nXDif < Global.nModAbstTol && nXDif > -Global.nModAbstTol) {
                j++;
                //valid
            } else {
                break;
            }
        }
        aResult = new Array(j);
        for (i = 0; i < j; i++) {
            aResult[i] = aTmp[i + iStart];
        }
        return aResult;
    }

    static VProfile_optimize(aCol: any[]): void {
        var i: number, j: number;
        var vprofileTmp: VLine;
        var vprofileCur: VLine;
        var abschblendTmp: VLine;
        var nYDif: number;
        var nYTol: number;
        nYTol = Sol50.nVertikalAbstand + Global.nModAbstTol;
        vprofileTmp = aCol[0];
        vprofileCur = new VLine(null);
        vprofileCur.t = vprofileTmp.t;
        vprofileCur.b = vprofileTmp.b;
        vprofileCur.x = vprofileTmp.x;
        Sol50OnRoof.aVProfile.push(vprofileCur);
        for (i = 1; i < aCol.length; i++) {
            vprofileTmp = aCol[i];
            if (vprofileTmp.t <= vprofileCur.b + nYTol) {
                vprofileCur.b = vprofileTmp.b;
            } else {
                //another one
                vprofileCur = new VLine(null);
                vprofileCur.t = vprofileTmp.t;
                vprofileCur.b = vprofileTmp.b;
                vprofileCur.x = vprofileTmp.x;
                Sol50OnRoof.aVProfile.push(vprofileCur);
            }
        }
    }
}
